import PropTypes from 'prop-types'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-HeaderStep'

const LandingInstantOfferHeaderStep = ({description, pretitle, title}) => {
  return (
    <>
      <span className={`${BASE_CLASS_NAME}Pretitle`}> {pretitle}</span>
      <h2 className={`${BASE_CLASS_NAME}Title`}>{title}</h2>
      {Boolean(description) && <p className={`${BASE_CLASS_NAME}Description`}>{description}</p>}
    </>
  )
}

LandingInstantOfferHeaderStep.displayName = 'LandingInstantOfferHeaderStep'

LandingInstantOfferHeaderStep.propTypes = {
  description: PropTypes.string,
  pretitle: PropTypes.string,
  title: PropTypes.string
}

export default LandingInstantOfferHeaderStep
